import { type Guard } from '../utils';

const hasPointsBeenIssued: Guard = ({ event }) => {
  if (event.type !== 'xstate.done.actor.submitForm') return false;

  return event.output.result === 'InStoreOrder';
};

const isTimeRestrictionError: Guard = ({ event }) => {
  if (event.type !== 'xstate.done.actor.submitForm') return false;

  return event.output.result === 'TimeRestrictionError';
};

const isReceiptAlreadyClaimedError: Guard = ({ event }) => {
  if (event.type !== 'xstate.done.actor.submitForm') return false;

  return event.output.result === 'ReceiptAlreadyClaimedError';
};

const isTransactionNotFoundError: Guard = ({ event }) => {
  if (event.type !== 'xstate.done.actor.submitForm') return false;
  return event.output.result === 'TransactionNotFoundError';
};

export const Guards = {
  hasPointsBeenIssued,
  isTimeRestrictionError,
  isReceiptAlreadyClaimedError,
  isTransactionNotFoundError,
};
